<template>
    <div class="map-right">
        <div class="header">
            <span>{{ mapObj.name }}</span>
            <i class="el-icon-refresh" style="color: var(--primary-color);font-size: 30px;cursor: pointer" @click="getCarrierData"></i>
        </div>
        <div class="content">
            <div
                v-for="(item, index) in carrierSceneNew"
                :key="index"
                class="content-item"
                :class="{ flashing: item.abnormal }"
            >
                <div class="content-item-info">
                    <span>{{ item.keycode }}</span>
                    <span>{{ $t('integration.type') + ': ' + $t(carrierTypeConvert(item.typeId).title) }}</span>
                </div>
                <div class="content-item-operate">
                    <div class="content-item-operate-item" @click="toSampleChart(item)">
                        <i
                            class="iconfont icon-zhexiantu cursor-pointer "
                            style="color: var(--primary-color);font-size: 30px"
                            :title="$t('integration.monitoring_point_chart')"
                        ></i>
                    </div>
                    <div class="content-item-operate-item" @click="toCarrierDetail(item)">
                        <i
                            class="el-icon-document"
                            style="color: var(--primary-color);font-size: 30px"
                            :title="$t('buttonTitle.Details')"
                        >
                        </i>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot">
            <el-checkbox v-model="enableRepoint">{{$t('integration.positioning_mode')}}</el-checkbox>
            <div class="foot-content">
                <div class="foot-content-item">
                    <el-tooltip effect="dark" :content="mapObjNew.address" placement="top" :enterable="false">
                        <el-input v-model="mapObjNew.address" :placeholder="$t('integration.please_select_address')" :disabled="!enableRepoint" />
                    </el-tooltip>
                    <div>
                        <el-input v-model="mapObjNew.longitude" :placeholder="$t('integration.please_select_longitude')" :disabled="!enableRepoint" />
                        <el-input v-model="mapObjNew.latitude" :placeholder="$t('integration.please_select_latitude')" :disabled="!enableRepoint" />
                    </div>
                </div>
                <div class="foot-content-item">
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        @click="searchAddress"
                        :disabled="!enableRepoint"
                    />
                    <el-button type="primary" class="foot-content-item-button" @click="saveMap"
                               :disabled="!enableRepoint">
                        <i class="el-icon-place" style="color: #FFFFFF" />
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { carrierTypeConvert } from '@/utils/convert'
import { carrierGetCarrierBySceneId, sceneSaveLatLng } from '@/api/modules/architecture'
import resultHandle from '@/common/resultHandle'
import { carrierDetail, carrierProbeHistory, transportHistory } from '@/utils/winDetail'

export default {
    props: {
        treeObj: {
            type: Object,
            default: () => ({})
        },
        mapObj: {
            type: Object,
            default: () => ({})
        },
        carrierScene: {
            type: Array,
            default: () => ([])
        },
        location: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            mapObjNew: {},
            carrierSceneNew: [],
            enableRepoint: false,
            addressSearch: null,
            checked: false
        }
    },
    watch: {
        mapObj: {
            handler(newVal) {
                this.mapObjNew = { ...newVal, sceneId: newVal.id }
            },
            immediate: true,
            deep: true
        },
        carrierScene: {
            handler(newVal) {
                this.carrierSceneNew = [...newVal]
            },
            immediate: true,
            deep: true
        },
        enableRepoint: {
            handler(newVal) {
                this.$emit('update:enableRepoint', newVal)
            }
        },
        location: {
            handler(newVal) {
                this.mapObjNew.address = newVal.address
                this.mapObjNew.longitude = newVal.longitude
                this.mapObjNew.latitude = newVal.latitude
            },
            deep: true
        }
    },
    mounted() {
    },
    methods: {
        carrierTypeConvert,
        searchAddress() {
            if (!this.mapObjNew?.address) return
            this.$emit('addressSearchFn', this.mapObjNew.address)
        },
        getCarrierData() {
            carrierGetCarrierBySceneId({ sceneId: this.treeObj.sceneId }).then(({ result }) => {
                this.carrierSceneNew = result
                this.$message.success($t('integration.operation_successful'));
            });
        },
        saveMap() {
            if (!this.mapObjNew) return
            sceneSaveLatLng(this.mapObjNew).then(async ({ result, state }) => {
                await resultHandle(state)
                this.$emit('update:mapObj', this.mapObjNew)
                // this.$message.success($t('integration.successful_positioning'));
            })
        },
        toSampleChart(carrier) {
            switch (carrier.mode) {
                case 1:
                    carrierProbeHistory({
                        carrierInfo: carrier
                    })
                    break
                case 2:
                    transportHistory({
                        carrierInfo: carrier
                    })
                    break
            }
        },
        toCarrierDetail(carrier) {
            if (!carrier) return
            carrierDetail(carrier.id, carrier.keycode, carrier.typeId)
        }
    }
}
</script>

<style scoped lang="scss">
.map-right {
    width: 300px;
    border: 1px solid $borderColor3;
    box-sizing: border-box;
    border-left: none;
    display: flex;
    flex-direction: column;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid $borderColor3;
}

.content {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 10px;
    padding: 10px;
    overflow-y: auto;
    min-height: 0;

    .content-item {
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        box-sizing: border-box;
        background-color: var(--primary-color);
        color: #fff;
        border-radius: 4px;
        border: 3px solid var(--primary-color);
        overflow: hidden;
        flex-shrink: 0;
        cursor: pointer;

        .content-item-info {
            display: flex;
            flex-direction: column;
            flex: 4;
            padding: 10px;
            gap: 25px;
        }

        .content-item-operate {
            position: relative;
            display: flex;
            flex-direction: column;
            flex: 1;

            .content-item-operate-item {
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 1;
                background-color: #fff;
                /* 在底部加线 */
                border-bottom: 1px solid var(--primary-color);
            }
        }

        /* 去掉最后一个的底部边框 */
        .content-item-operate-item:last-child {
            border-bottom: none;
        }

        .content-item-operate-item:first-child {
            border-top-right-radius: 2px;
        }

        .content-item-operate-item:last-child {
            border-bottom-right-radius: 2px;
        }

    }

    @keyframes flash-border {
        0%, 100% {
            border-color: red; /* 颜色 A */
        }
        50% {
            border-color: var(--primary-color); /* 颜色 B */
        }
    }

    .content-item.flashing {
        /* 1s 一轮，线性，交替（来回切换），无限次 */
        animation: flash-border 1s linear infinite;
    }
}

.foot {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    border-top: 1px solid $borderColor3;

    .foot-content {
        display: flex;
        justify-content: space-between;
        align-items: stretch;

        .foot-content-item {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        .foot-content-item-button {
            flex: 1;
        }
    }
}
</style>
